import type { ReactNode } from 'react';

import React, { createContext, useContext, useState } from 'react';

interface MarketplaceData {
  source: string;
  title: string;
  url: string;
}

export interface MarketplaceContextType {
  clearMarketplaceData: () => void;
  marketplaceData: MarketplaceData | null;
  setMarketplaceData: (data: MarketplaceData) => void;
}

const MarketplaceContext = createContext<MarketplaceContextType | undefined>(undefined);

interface MarketplaceProviderProps {
  children: ReactNode;
}

export function MarketplaceProvider({ children }: MarketplaceProviderProps) {
  const [marketplaceData, setMarketplaceDataState] = useState<MarketplaceData | null>(null);

  const setMarketplaceData = (data: MarketplaceData) => {
    setMarketplaceDataState(data);
  };

  const clearMarketplaceData = () => {
    setMarketplaceDataState(null);
  };

  const value: MarketplaceContextType = {
    marketplaceData,
    setMarketplaceData,
    clearMarketplaceData,
  };

  return <MarketplaceContext.Provider value={value}>{children}</MarketplaceContext.Provider>;
}

export function useMarketplaceContext() {
  return useContext(MarketplaceContext);
}
